import React, { FC } from 'react';
import classNames from 'classnames';
import cls from './Radio.module.css';

interface RadioProps {
    title?: string;
    isSelected: boolean;
    onClick?: (value: string) => void;
    isDisabled?: boolean;
    children?: React.ReactNode;
    value?: string;
    classes?: string;
}

export const Radio: FC<RadioProps> = ({
    title,
    isSelected,
    isDisabled = false,
    children,
    value,
    onClick,
    classes,
}) => {
    return (
        <div
            className={classNames(cls.wrapper, { [cls.disabled]: isDisabled }, classes)}
            onClick={() => onClick(value)}
        >
            <div className={classNames(cls.customRadio)}>
                <input
                    type="radio"
                    name="radio"
                    checked={isSelected}
                    readOnly
                    className={cls.radioInput}
                />
                <div
                    className={classNames(cls.radioCircle, {
                        [cls.selected]: isSelected,
                    })}
                />
            </div>
            {title && <span className={cls.title}>{title}</span>}
            {children}
        </div>
    );
};
